import { render, staticRenderFns } from "./inner-feature.vue?vue&type=template&id=9b9d0072&"
import script from "./inner-feature.vue?vue&type=script&lang=js&"
export * from "./inner-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports